import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { PeriodDetail } from "./PeriodDetail";
import { StatusPill, fmtDate, money, signedMoney } from "./_shared";

export function PeriodsTable({ periods, onChanged }) {
  const [openKey, setOpenKey] = useState(() => periods.find((p) => p.status === "to_file" && p.ready)?.key || null);

  return (
    <div className="bg-white border rounded-xl overflow-hidden" data-testid="periods-table">
      <div className="hidden md:grid grid-cols-[minmax(0,2fr)_1fr_1fr_1fr_1fr_1fr_1.2fr_auto] gap-2 px-4 py-2 bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500 font-semibold">
        <div>Période</div><div className="text-right">Ventes (101)</div><div className="text-right">TPS perçue (103)</div><div className="text-right">CTI (106)</div>
        <div className="text-right">TVQ perçue (203)</div><div className="text-right">RTI (206)</div><div className="text-right">À remettre</div><div className="w-24 text-center">Statut</div>
      </div>
      {periods.map((p) => {
        const open = openKey === p.key;
        return (
          <div key={p.key} className="border-t first:border-t-0">
            <button onClick={() => setOpenKey(open ? null : p.key)}
              className={`w-full text-left px-4 py-3 grid grid-cols-2 md:grid-cols-[minmax(0,2fr)_1fr_1fr_1fr_1fr_1fr_1.2fr_auto] gap-2 items-center hover:bg-slate-50 transition ${open ? "bg-indigo-50/40" : ""}`}
              data-testid={`period-row-${p.key}`}>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-slate-900 flex items-center gap-1.5">
                  {open ? <ChevronUp className="w-3.5 h-3.5 text-slate-400" /> : <ChevronDown className="w-3.5 h-3.5 text-slate-400" />}
                  <span className="truncate">{p.label}</span>
                </div>
                <div className="text-[11px] text-slate-500 pl-5">
                  Échéance {fmtDate(p.due_date)} · {p.sales_count} vente{p.sales_count > 1 ? "s" : ""} · {p.purchases_count} achat{p.purchases_count > 1 ? "s" : ""}
                  {p.drafts_count > 0 && <span className="text-orange-700 font-semibold" data-testid={`period-drafts-${p.key}`}> · {p.drafts_count} non reportée{p.drafts_count > 1 ? "s" : ""}</span>}
                  {p.has_adjustments && <span className="text-amber-700 font-semibold" data-testid={`period-adjusted-${p.key}`}> · montants ajustés</span>}
                </div>
              </div>
              <div className="hidden md:block text-right text-sm tabular-nums">{money(p.line_101_sales)}</div>
              <div className="hidden md:block text-right text-sm tabular-nums">{money(p.line_103_tps_collected)}</div>
              <div className="hidden md:block text-right text-sm tabular-nums text-slate-600">{money(p.line_106_cti)}</div>
              <div className="hidden md:block text-right text-sm tabular-nums">{money(p.line_203_tvq_collected)}</div>
              <div className="hidden md:block text-right text-sm tabular-nums text-slate-600">{money(p.line_206_rti)}</div>
              <div className={`text-right text-sm font-bold tabular-nums ${p.net_total < 0 ? "text-emerald-700" : "text-indigo-900"}`} data-testid={`period-net-${p.key}`}>{signedMoney(p.net_total)}</div>
              <div className="w-24 flex justify-end md:justify-center"><StatusPill period={p} /></div>
            </button>
            {open && <PeriodDetail period={p} onChanged={onChanged} />}
          </div>
        );
      })}
    </div>
  );
}
